<template>
  <div id="yhubDetail">
    <!-- 设备基本信息 -->
    <el-row>
      <div class="paneDivWarp" style="padding-bottom: 10px;">
        <p class="flowP">
          {{ yhubSn }}
          <span>{{ yhubInfoTem.timeAgo }}</span>
        </p>
        <div class="flowDivWarp">
          <div>
            <img src="@/assets/images/kisae/flowChart/yhubFlow.jpg" alt="" style="width: 100%;">
            <!-- <div class="flowDataWarp">
              <div>
                <p>{{ yhubInfoTem.soc }} %</p>
                <p>{{ yhubInfoTem.voltage }} V</p>
                <p>{{ yhubInfoTem.current }} A</p>
              </div>
              <div>
                <p>{{ yhubInfoTem.capacity }} Ah</p>
                <p>
                  <span v-if="yhubInfoTem.batteryTemperature<'-20'" class="infoP">Not Installed</span>
                  <span v-else-if="yhubInfoTem.batteryTemperature>=120" class="infoP">Abnormal Temperature</span>
                  <span v-else-if="!yhubInfoTem.batteryTemperature&&yhubInfoTem.batteryTemperature!=0" class="infoP">--</span>
                  <span v-else class="infoP">{{ yhubInfoTem.batteryTemperature }} ℃</span>
                </p>
                <p>
                  <span v-if="yhubInfoTem.level==-1" class="infoP">Level:Not Installed</span>
                  <span v-else-if="yhubInfoTem.level===0" class="infoP" style="color:red;">Level:Bad }}</span>
                  <span v-else-if="yhubInfoTem.level==1" class="infoP">Level:Normal</span>
                  <span v-else-if="!yhubInfoTem.level&&yhubInfoTem.level!=0" class="infoP">--</span>
                </p>
              </div>
            </div> -->
          </div>
        </div>
        <div>
          <el-table :data="yhubTableList" :show-header="false" element-loading-text="Loading" border fit highlight-current-row>
            <el-table-column label="left" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.leftVlue }}</span>
              </template>
            </el-table-column>
            <el-table-column label="right" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.rightVlue }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import i18n from '@/i18n'
import { updateTimeOnlyEn } from '@/utils/updateTime.js'
import { temChangeUnit } from '@/utils/temChange.js'

export default {
  name: '',
  props: {
    yhubTabPaneInfo: {
      type: Object,
      default: () => { }
    },
    yhubSn: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      yhubInfoTem: {
        soc: '--',
        voltage: '--',
        current: '--',
        capacity: '--',
        batteryTemperature: '--',
        level: '--',
        timeAgoRes: null,
        timeAgo: null,
        currentInfo: ''
      },
      oldCapacity: '',
      oldLevel: '',
      timer: null,
      yhubTableList: []
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    yhubTabPaneInfo: {
      handler(newValue, oldValue) {
        // this.yhubInfoTem = newValue // 把新值赋值给我们的属性数据
        // console.log('watch*********', this.yhubInfoTem)
        this.MQTT()
      },
      deep: true,
      immediate: true
    },
    language(newValue, oldValue) {
      if (this.yhubInfoTem.timeAgoRes) this.yhubInfoTem.timeAgo = updateTimeOnlyEn(this.yhubInfoTem.timeAgoRes)
    }
  },
  created() {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  destroyed: function() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    MQTT() {
      console.log('mqtt**yhubTem********', this.yhubTabPaneInfo)
      this.yhubInfoTem.currentInfo = 'CURRENT'
      if (this.yhubTabPaneInfo.dataFrom == 'api') {
        this.yhubInfoTem.timeAgoRes = this.yhubTabPaneInfo.timeAgoRes
        this.yhubInfoTem.timeAgo = updateTimeOnlyEn(this.yhubInfoTem.timeAgoRes)
        if (this.yhubTabPaneInfo.currentCharging > 0) {
          this.yhubInfoTem.isCharged = 'charged'
          this.yhubInfoTem.currentInfo = 'CHARGING CURRENT'
          this.yhubInfoTem.current = (this.yhubTabPaneInfo.currentCharging / 100).toFixed(2)
          this.yhubInfoTem.voltage = (this.yhubTabPaneInfo.voltageRaw / 100).toFixed(2)
        }
        if (this.yhubTabPaneInfo.currentUsing > 0) {
          this.yhubInfoTem.isCharged = 'disCharged'
          this.yhubInfoTem.currentInfo = 'DISCHARGING CURRENT'
          this.yhubInfoTem.current = (this.yhubTabPaneInfo.currentUsing / 100).toFixed(2)
          this.yhubInfoTem.voltage = (this.yhubTabPaneInfo.voltageRaw / 100).toFixed(2)
        }
        if (this.yhubTabPaneInfo.currentCharging == 0 && this.yhubTabPaneInfo.currentUsing == 0) {
          this.yhubInfoTem.isCharged = 'idel'
          this.yhubInfoTem.currentInfo = 'CURRENT'
          this.yhubInfoTem.current = 0
          this.yhubInfoTem.voltage = 0
        }
        if (this.yhubTabPaneInfo.soc > 10000) {
          this.yhubInfoTem.soc = Math.round(this.yhubTabPaneInfo.soc / 10000)
        } else if (this.yhubTabPaneInfo.soc > 100) {
          this.yhubInfoTem.soc = Math.round(this.yhubTabPaneInfo.soc / 100)
        } else {
          this.yhubInfoTem.soc = Math.round(this.yhubTabPaneInfo.soc)
        }
        if (this.yhubTabPaneInfo.batteryCapacity || this.yhubTabPaneInfo.batteryCapacity == 0) {
          this.yhubInfoTem.capacity = this.yhubTabPaneInfo.batteryCapacity > 1000 ? Math.round(this.yhubTabPaneInfo.batteryCapacity / 100) : this.yhubTabPaneInfo.batteryCapacity
        } else {
          this.yhubInfoTem.capacity = '--'
        }
        this.oldCapacity = this.yhubInfoTem.capacity
        this.oldLevel = this.yhubInfoTem.level = this.yhubTabPaneInfo.level
        if ((this.yhubTabPaneInfo.batteryTemperature && this.yhubTabPaneInfo.batteryTemperature != '--') || this.yhubTabPaneInfo.batteryTemperature == 0) {
          this.yhubInfoTem.batteryTemperature = this.yhubTabPaneInfo.batteryTemperature > 1000 ? Math.round(this.yhubTabPaneInfo.batteryTemperature / 100) : this.yhubTabPaneInfo.batteryTemperature
        } else {
          this.yhubInfoTem.batteryTemperature = '--'
        }
      } else if (this.yhubTabPaneInfo.dataFrom == 'mqtt') {
        if (!this.yhubTabPaneInfo) return
        this.yhubInfoTem.timeAgo = 'A Moment Ago'
        this.yhubInfoTem.timeAgoRes = new Date().getTime()
        console.log('yhubTabPaneInfo-------', this.yhubTabPaneInfo)
        this.yhubInfoTem.voltage = (this.yhubTabPaneInfo.voltageRaw / 100).toFixed(2)
        this.yhubInfoTem.current = ((this.yhubTabPaneInfo.currentCharging - this.yhubTabPaneInfo.currentDischarging) / 100).toFixed(2)
        this.yhubInfoTem.soc = Math.round(this.yhubTabPaneInfo.soc / 100)
        this.yhubInfoTem.batteryTemperature = Math.round(this.yhubTabPaneInfo.batteryTemperature / 100)
        this.yhubInfoTem.capacity = this.oldCapacity
        this.yhubInfoTem.level = this.oldLevel
        if (this.yhubTabPaneInfo.current > 0) {
          this.yhubInfoTem.currentInfo = 'CHARGING CURRENT'
        } else if (this.yhubTabPaneInfo.current < 0) {
          this.yhubInfoTem.currentInfo = 'DISCHARGING CURRENT'
        } else {
          this.yhubInfoTem.currentInfo = 'CURRENT'
        }
      }
      if (this.yhubInfoTem.batteryTemperature < '-20') {
        this.yhubInfoTem.batteryTem = 'Not Installed'
      } else if (this.yhubInfoTem.batteryTemperature >= 125) {
        this.yhubInfoTem.batteryTem = 'Abnormal Temperature'
      } else if (!this.yhubInfoTem.batteryTemperature && this.yhubInfoTem.batteryTemperature != 0) {
        this.yhubInfoTem.batteryTem = '--'
      } else {
        this.yhubInfoTem.batteryTem = temChangeUnit(this.yhubInfoTem.batteryTemperature)
      }
      switch (this.yhubInfoTem.level) {
        case -1:this.yhubInfoTem.levelInfo = 'Not Installed'; break
        case 0:this.yhubInfoTem.levelInfo = 'Bad'; break
        case 1:this.yhubInfoTem.levelInfo = 'Normal'; break
        default:this.yhubInfoTem.levelInfo = '--'; break
      }
      this.yhubTableList = [
        { leftVlue: 'SOC = ' + this.yhubInfoTem.soc + '%', right: 'CAPACITY=', rightVlue: 'CAPACITY = ' + this.yhubInfoTem.capacity + 'Ah' },
        { leftVlue: 'VOLTAGE = ' + this.yhubInfoTem.voltage + 'V', rightVlue: 'TEMPERATURE = ' + this.yhubInfoTem.batteryTem },
        { leftVlue: this.yhubInfoTem.currentInfo + ' = ' + this.yhubInfoTem.current + 'A', rightVlue: 'LEVEL = ' + this.yhubInfoTem.levelInfo }
      ]
    },
    setTimer() { // 定时器
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.yhubInfoTem.timeAgoRes) this.yhubInfoTem.timeAgo = updateTimeOnlyEn(this.yhubInfoTem.timeAgoRes)
        }, 60000)
      }
    },
    decimalToBinary(num) { // 十进制转二进制
      var myNum = num
      var b = []
      while (1) {
        var remainder = num % 2
        b.unshift(remainder)
        num = parseInt(num / 2)
        if (num == 0) break
      }
      var len
      if (myNum < 10) {
        len = 4 - b.length
        for (var i = 0; i < len; i++) {
          b.unshift(0)
        }
      } else if (myNum >= 10 && myNum < 100) {
        len = 8 - b.length
        for (var j = 0; j < len; j++) {
          b.unshift(0)
        }
      }
      return b.reverse()
      // return b
    }

  }
}
</script>
<style lang="scss">
#yhubDetail{
  .flowDataWarp{
    position: absolute;
    left: 53.8%;
    top: 82%;
  }
  .flowDataWarp div{
    display: inline-block;
    margin-right: 20px;
  }
  .flowDataWarp div p{
    line-height:26px;
    height:26px;
  }
  .el-table--border{
    border:1px solid #fff;
  }
  table th, tr {
    height: 28px;
  }
  .el-table--medium td{
    padding:0!important;
  }
  .el-table {
    width: 80%;
    margin:10px 10% 0 10%;
  }
  .el-table tr {
    font-size: 14px;
    color: #fff;
    background-color: #26679f;
  }
  .el-table--group::after, .el-table--border::after, .el-table::before,.el-table--group::after, .el-table--border::after, .el-table::before {
    background-color: #27679e;
  }
  .el-table tr:hover ,.el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: #4c99dc;
  }
}
</style>
